import { Dropdown } from "antd"
import PropTypes from "prop-types"
import MoreActionEllipsis from "ui/MoreActionEllipsis"
import { Text } from "ui/Typography"
import TimeOffNotFound from "../TimeOffNotFound"
import { getTimeOffColumns, TIME_OFF_BE_KEYS } from "pagesV2/pro/Calendar/constants"
import styles from "../index.module.css"
import { useDevice } from "hooks/useDevice"

const TimeOffSingleDay = ({ timeOff, getDropdownItems }) => {
  const columns = getTimeOffColumns(TIME_OFF_BE_KEYS.singleDay);
  const { isMobile } = useDevice();
  if (timeOff?.length === 0) {
    return <TimeOffNotFound type="single day" colSpan={columns.length} />;
  }

  return (
    <tbody>
      {timeOff?.map((item) => {
        const { id, start_time, end_time, season_start, all_day } = item || {};
        return (
          <tr key={id}>
            <td data-label={columns[0]}>
              <Text>{season_start}</Text>
            </td>
            <td data-label={columns[1]}>
              <Text>{all_day ? "Full Day" : (start_time ?? "-")}</Text>
            </td>
            <td data-label={columns[2]}>
              <Text>{all_day ? "Full Day" : (end_time ?? "-")}</Text>
            </td>
            <td data-label={columns[3]} className={styles.actionColumn}>
              <Dropdown trigger={["click"]} placement="bottomRight" menu={{ items: getDropdownItems(item) }}>
                {isMobile ? <Text className={styles.moreText}> More actions</Text> : <MoreActionEllipsis />}
              </Dropdown>
            </td>
          </tr>
        );
      })}
    </tbody>
  );
};

TimeOffSingleDay.propTypes = {
  timeOff: PropTypes.array,
  getDropdownItems: PropTypes.func
}

export default TimeOffSingleDay
